/**
 * VIO tokens for this page only (memory). The host re-delivers fresh tokens
 * on every load — URL params or VIO_AUTH_TOKENS — so nothing is persisted:
 * opening the app again without tokens can never pick up a previous member's
 * session (one origin is iframed by several tenants and members).
 */
const state = { accessToken: null, refreshToken: null, redirectUrl: null };

export const withoutBearer = (token) => {
  if (!token) return null;
  const value = String(token).replace(/^Bearer\s+/i, "").trim();
  return value || null;
};

export const tokenStore = {
  getAccessToken: () => state.accessToken,
  setAccessToken: (token) => { state.accessToken = withoutBearer(token); },
  getRefreshToken: () => state.refreshToken,
  setRefreshToken: (token) => { state.refreshToken = withoutBearer(token); },
  // Member App base (origin + tenant path) for voucher links outside the host.
  getRedirectUrl: () => state.redirectUrl,
  setRedirectUrl: (url) => { state.redirectUrl = url || null; },
  clearTokens: () => {
    state.accessToken = null;
    state.refreshToken = null;
  },
};

// Keys older versions kept in localStorage (incl. other members' tokens).
const LEGACY_KEYS = [
  "accessToken", "refreshToken", "user_token", "userInfo", "userId", "company",
  "redirectUrl", "pwaUrl", "refreshTokenUsedInPWA", "refreshTokenUsedAt",
];

export function clearLegacyStorage() {
  try {
    LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch (_) {
    // storage blocked (private mode / partitioned iframe): nothing to clear
  }
}
